import urlResource from '../home/constants/UrlResources';

export function getQueryValue(name, location) {
  if (!location || !location.search) return '';

  const queryName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${queryName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(location.search);

  if (!results) return null;
  if (!results[2]) return '';

  try {
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  } catch (error) {
    return results[2].replace(/%20/g, ' ');
  }
}

export function getAttributesFromUrl(location) {
  return location.pathname.split('?')[0].split('/');
}

export function getFaqInfo(location) {
  const attributes = getAttributesFromUrl(location);
  const articleIdWithTitle = attributes[2] || '';
  const urlSegments = decodeURIComponent(articleIdWithTitle).split('-');
  const articleId = (urlSegments[urlSegments.length - 1]).toUpperCase();

  return {
    name: urlResource.ARTICLE,
    id: articleId,
  };
}

export function getTopicInfo(location) {
  const attributes = getAttributesFromUrl(location);
  return {
    name: urlResource.TOPIC,
    id: attributes[2],
  };
}

export function getResourceInfoForHome() {
  return {
    name: urlResource.HOME,
  };
}

function getQueryForSearch(location) {
  return {
    name: urlResource.SEARCH,
    searchTerm: getQueryValue('q', location),
    channelOption: getQueryValue('channel', location),
  };
}

export function getPayPalGuideInfo() {
  return {
    name: urlResource.PAYPALGUIDE,
  };
}

export function parseResourceInfoFromLocation(location) {
  const attributes = getAttributesFromUrl(location);
  const resource = attributes[1];

  switch (resource) {
    case urlResource.ARTICLE:
      return getFaqInfo(location);
    case urlResource.TOPIC:
      return getTopicInfo(location);
    case urlResource.HOME:
      return getResourceInfoForHome();
    case urlResource.SEARCH:
      return getQueryForSearch(location);
    case urlResource.PAYPALGUIDE:
      return getPayPalGuideInfo();
    default: {
      return {};
    }
  }
}

/*
 What's the sample output of getPageUrlInfoFromLocation function??

 Sample Url's:
 =============

 home page =  /smarthelp/personal/home
 article page  = /smarthelp/personal/article/838
 topic list page = /smarthelp/personal/L1TopicId/L2TopicId

 Page Info Parsed:
 ================

 home page = {
 experience: 'personal',
 resource: {
 name: 'home',
 },
 }

 article page = {
 experience: 'personal',
 resource: {
 name: 'article',
 id: '838',
 },
 }

 topic list page = {
 experience: 'personal',
 resource: {
 name: 'topic',
 id: 'L2TopicId',
 topicTree: [L1TopicId, L2TopicId]
 },
 }
 */
export function getPageUrlInfoFromLocation(location) {
  return {
    experience: location.experience,
    resource: parseResourceInfoFromLocation(location),
  };
}

/**
 *  Function to clean the path name if the pathname is prefixed with basename.
 * @param location
 * @returns {*} - location object
 */
export function getParsedPathName(location) {
  const pathName = location.pathname;

  // Check the route has smarthelp in pathName
  const smartHelpExistsInPath = pathName.includes('smarthelp/');
  if (smartHelpExistsInPath) {
    const parsedPath = pathName.substring(pathName.indexOf('smarthelp/') + 9);
    return { ...location, pathname: parsedPath };
  }

  // Check the route has selfhelp in pathName
  const isSelfHelpExistsInPath = pathName.includes('selfhelp/');
  if (isSelfHelpExistsInPath) {
    const parsedPath = pathName.substring(pathName.indexOf('selfhelp/') + 8);
    return { ...location, pathname: parsedPath };
  }

  return location;
}

export function getCurrentRouteResourceName(location) {
  try {
    const currentLocationPathName = getAttributesFromUrl(location);
    return currentLocationPathName[1];
  } catch (e) {
    return '';
  }
}
